module.exports = __webpack_public_path__ + "static/office_4-98d9769b1e990d32d3ce10bb1663eb03.jpg";